/**
 * 区分 messageDirectionType（contact_messages.message_direction_type）
 * 出典：要件書 5.2
 */
export const MESSAGE_DIRECTION_TYPE_VALUES = ['inbound', 'outbound'] as const;

export type MessageDirectionType = (typeof MESSAGE_DIRECTION_TYPE_VALUES)[number];

export const MESSAGE_DIRECTION_TYPE_LABELS: Readonly<Record<MessageDirectionType, string>> = {
  inbound: '受信',
  outbound: '送信',
};
